import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import LogoImage from '../images/wickidcool-logo.png'

const Container = styled.div`
  flex: 1;
  min-height: 100px;
`

const LogoContainer = styled.div`
  float: left;
  width: 20%;
`

const MenuContainer = styled.div`
  padding: 30px 0 0 30px;
  float: left;
  text-align: center;
  width: 40%;
`

const SocialMediaContainer = styled.div`
  padding: 20px 0 0 30px;
  font-size: 24px;
  color: #445E32;
  width: 33%;
  
  float: left;
`

const StyledLink = styled(Link)`
  text-decoration: none;
  padding: 20px;
  width: 20%;
  color: #445E32;
  border-right: solid;
  
  .text {
    padding-right: 10px;
    font-size: 24px;
  }
  
  &:hover {
    color: blue;
  }
`

const Header = ({ siteTitle }) => (
  <Container>
    <LogoContainer >
      <Link to='/'>
        <img src={LogoImage} />
      </Link>
    </LogoContainer>

    <MenuContainer>
      {/* <StyledLink to='/'>
        <span className='text'>Home</span>
      </StyledLink> */}
{/* 
      <StyledLink to='/training'>
        <span className='text'>Training</span>
      </StyledLink> */}

      {/* <StyledLink to='/projects'>
        <span className='text'>Projects</span>
      </StyledLink> */}
    </MenuContainer>

    <SocialMediaContainer >
      <div>
        <i className='fa fa-facebook-square' /> @wickidcool
      </div>
      <div>
        <i className='fa fa-linkedin-square' /> Wickidcool Software
      </div>
    </SocialMediaContainer>
  </Container>
)

export default Header